import { render } from "./Titulo.vue?vue&type=template&id=3c1b4e15"
import script from "./Titulo.vue?vue&type=script&lang=js"
export * from "./Titulo.vue?vue&type=script&lang=js"

import "./Titulo.vue?vue&type=style&index=0&id=3c1b4e15&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__